<template>
  <div class="container">
    <div class="section p-0">
      <div class="box mt-0">
        <div class="columns">
          <div class="column is-4">
            <h1 class="title is-4">{{ $t("reports") }}</h1>
          </div>
          <div class="column is-8">
            <p class="buttons is-pulled-right">
              <button class="button is-rounded" @click="generate_dictionary">
                <span class="icon has-text-info">
                  <i class="fa fa-book"></i>
                </span>
                <span>{{ $t("generate dictionary") }}</span>
              </button>
              <button class="button is-rounded" @click="import_report">
                <span class="icon has-text-primary">
                  <i class="fa fa-download"></i>
                </span>
                <span>{{ $t("import") }}</span>
              </button>
              <button class="button is-rounded" @click="create">
                <span class="icon has-text-warning">
                  <i class="fa fa-modx"></i>
                </span>
                <span>{{ $t("create report") }}</span>
              </button>
              <button class="button is-primary is-rounded" @click="init">
                <span class="icon">
                  <i class="fa fa-refresh"></i>
                </span>
                <span>{{ $t("refresh") }}</span>
              </button>
            </p>
          </div>
        </div>
        <div class="table-container">
          <table class="table is-fullwidth is-hoverable">
            <thead>
              <tr>
                <th>{{ $t("name") }}</th>
                <th>{{ $t("options") }}</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="rpt in reports" :key="rpt.id">
                <td>
                  <span class="title is-6 is-flex">
                    <figure class="image is-32x32">
                      <img class="" :src="rpt.icon" />
                    </figure>
                    <span class="ml-2 pt-2"
                      >{{ rpt.name ? $t(rpt.name) : ""
                      }}<span class="subtitle is-6 pl-2">{{
                        rpt.version
                      }}</span></span
                    >
                  </span>
                </td>
                <td>
                  <p class="buttons is-pulled-right">
                    <button
                      class="button is-rounded is-small"
                      @click="install_report(rpt)"
                      v-if="!rpt.exist_in_database"
                      :data-tooltip="$t('install')"
                    >
                      <span class="icon has-text-primary">
                        <i class="fa fa-bolt"></i>
                      </span>
                      <!-- <span>{{ $t("install") }}</span> -->
                    </button>
                    <button
                      class="button is-rounded is-small"
                      @click="uninstall_report(rpt)"
                      v-if="rpt.exist_in_database"
                      :data-tooltip="$t('uninstall')"
                    >
                      <span class="icon has-text-danger">
                        <i class="fa fa-unlink"></i>
                      </span>
                      <!-- <span>{{ $t("uninstall") }}</span> -->
                    </button>
                    <button
                      class="button is-rounded is-small"
                      @click="permissions(rpt)"
                      v-if="rpt.exist_in_database"
                      :data-tooltip="$t('permissions')"
                    >
                      <span class="icon has-text-warning">
                        <i class="fa fa-key"></i>
                      </span>
                      <!-- <span>{{ $t("permissions") }}</span> -->
                    </button>
                    <button
                      class="button is-rounded is-small"
                      @click="remove(rpt)"
                      :data-tooltip="$t('delete')"
                      v-if="!rpt.exist_in_database"
                    >
                      <span class="icon has-text-danger">
                        <i class="fa fa-trash"></i>
                      </span>
                    </button>
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <permissions-modal ref="permissions_modal"></permissions-modal>
    <report-modal ref="report_modal" @success="init"></report-modal>
    <import-modal ref="import_modal"></import-modal>
  </div>
</template>

<script>
import {
  get,
  error_message,
  put,
  del,
  post,
  confirm_deletion_dialog,
  success_message,
} from "@/utils";
import PermissionsModal from "./permissions_modal/Index.vue";
import ReportModal from "./report_modal/Index.vue";
import ImportModal from "./import_modal/Index.vue";

export default {
  name: "ReportManager",
  components: { PermissionsModal, ReportModal, ImportModal },
  data() {
    return {
      reports: [],
      is_waiting_for_build: false,
    };
  },
  computed: {},
  methods: {
    init() {
      let v = this;
      get("/report/manage", {})
        .then((r) => {
          // console.log("modules", r);
          v.reports = r;
        })
        .catch((error) => {
          error_message(error);
        });
    },
    install_report(rpt) {
      let v = this;
      put("/report/install", { name: rpt.name, pth: rpt.report_path })
        .then(() => {
          success_message(v.$t("report installed"));
          v.init();
        })
        .catch((error) => {
          error_message(error);
        });
    },
    uninstall_report(rpt) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to uninstall this report?"),
        v,
        () => {
          del("/report/install", { uuid: rpt.uuid })
            .then(() => {
              success_message(v.$t("report uninstalled"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    permissions(mdle) {
      let v = this;
      v.$refs.permissions_modal.show_modal(mdle);
    },
    create() {
      let v = this;
      // v.$refs.report_modal.show_modal();
      v.$router.push({ path: "/report/editor" });
    },
    remove(rpt) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to remove this report?"),
        v,
        () => {
          del("/report", { path: rpt.report_path })
            .then(() => {
              success_message(v.$t("report removed"));
              v.init();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    import_report() {
      let v = this;
      v.$refs.import_modal.show_modal();
    },
    generate_dictionary() {
      let v = this;
      v.is_waiting_for_build = true;
      post("/report/dictionary", {})
        .then(() => {
          success_message(v.$t("dictionary generated"));
          v.is_waiting_for_build = false;
        })
        .catch((error) => {
          error_message(error);
          v.is_waiting_for_build = false;
        });
    },
  },
  mounted() {
    let v = this;
    v.init();
  },
};
</script>

<style></style>
